import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { msg } from 'api';

export default class CorporateList extends PureComponent {
  static propTypes = {
    cookieLink: PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  };

  render() {
    const msgs = msg.footers.footer;
    const { cookieLink } = this.props;
    const liClass = 'ft-corporate__listItem';
    const aClass = 'ft-footer__link ft-corporate__link';
    return (
      <ul className="ft-corporate__list">
        {msgs.groupCorporateLink && (
          <li className={liClass}>
            <a href={msgs.groupCorporateLink} className={aClass}>
              {msgs.groupCorporate}
            </a>
          </li>
        )}
        {msgs.careersCorporateLink
          ? (
            <li className={liClass}>
              <a href={msgs.careersCorporateLink} className={aClass}>
                {msgs.careersCorporate}
              </a>
            </li>
          )
          : null
        }
        {msgs.sitemapCorporateLink
          ? (
            <li className={liClass}>
              <a href={msgs.sitemapCorporateLink} className={aClass}>
                {msgs.sitemapCorporate}
              </a>
            </li>
          )
          : null
        }
        {msgs.termsCorporateLink
          ? (
            <li className={liClass}>
              <a href={msgs.termsCorporateLink} className={aClass}>
                {msgs.termsCorporate}
              </a>
            </li>
          )
          : null
        }
        {cookieLink
          ? (
            <li className={liClass}>
              <a href={cookieLink.url} className={aClass}>
                <strong>{cookieLink.title}</strong>
              </a>
            </li>
          )
          : null
        }
      </ul>
    );
  }
}
